import React from 'react';
import Secondaryctashort from './secondaryshort';
import Primaryctashort from './primaryshortcta';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import pic35 from '../../assets/pic35.png'




const Exit = ({ onCancel,currentLevel }) => {

         const [closing, setClosing] = useState(false);

         const navigate = useNavigate();

        const handleBack = () => {
            setClosing(true);
            setTimeout(() => onCancel(), 400);
        };
        const handleStart = () => {
            localStorage.setItem('currentLevel', currentLevel);

            setClosing(true);

            setTimeout(() => {
                navigate('/home');
            }, 400);
        };

    return (  <>
<main>
            <section className='levelbackground--page'>
           
 <>
       

               <section className='settings-background'>
            <section className={`mission-overlay ${closing ? 'slide-down' : 'slide-up'}`}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>Exit?</h2>
                        <h2 className='title2-container-settings'>Exit?</h2>
                    </div>
                    
                        <button className='circlecta-cont' >
                         <div onClick={handleBack}>
                            <div className='circle-red'>
                                <img className='close-img' src={pic35} alt='close'></img>
                            </div>
                        </div>
                    </button>
                </section>


                <section className='container-mission'>
                    <section className='container-audio'>

                        <p className='para-mission'>Are you sure you want to
                             leave the game? You might lose all your progress.</p>

                    </section>
                </section>



                <div className='container-continue-how-to-play' >
                     <div onClick={handleStart}>
                    <Primaryctashort title='Exit' />
                    </div>
                    <div onClick={handleBack}>
                        <Secondaryctashort  title='Cancel'/>
                    </div>

                 
                </div>



                </section>
            </section>
        </>
              

               
            </section>
          </main>

         </> );
}
 
export default Exit;